import React from 'react';
import Head from 'next/head';
import useTranslation from 'next-translate/useTranslation';
import { Col, Container, Row } from 'react-bootstrap';
import Image from 'next/image';
import { useIsSmallScreen } from '@/hooks/useIsSmallScreen';
import templateDataService from '@/services/template-data-service';
import styles from './LoginLayout.module.scss';

export const LoginLayout = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation();
  const templateData = templateDataService.getTemplateData();
  const isSmallScreen = useIsSmallScreen();

  return (
    <>
      <Head>
        <title>{t('common:mijn-carellurvink.page-title')}</title>
      </Head>

      <main className={`${styles.main} py-3 mb-3`}>
        <Container>
          <Row className="d-flex align-items-center justify-content-center">
            <Col className="text-center">
              <Image src={templateData.sector.logo} alt="Carel Lurvink logo" width={118} height={96} priority />
            </Col>
          </Row>
          <Row className="d-flex align-items-center justify-content-center">
            <Col className="text-center">
              <Image
                height={!isSmallScreen ? 246 : 115}
                width={!isSmallScreen ? 690 : 330}
                src={!isSmallScreen ? '/images/next/login/four-people.png' : '/images/next/login/four-people-mobile.png'}
                alt="?"
              />
            </Col>
          </Row>
        </Container>

        {children}
      </main>
    </>
  );
};
